import React, {Component} from 'react';
import _ from 'lodash'
import {Button, Modal } from 'react-bootstrap';

export default class RemoveModalDialog extends Component {

    constructor(props, context) {
        super(props, context);

        this.removeRecord = _.throttle(this.removeRecord, 2000, {
            'leading': true,
            'trailing': false
        });
    }
    removeRecord(){
        this.props.removeRecord()
    }


    render() {
         if (!this.props.show) {
            return null;
        }
        return (
        <Modal  show={this.props.show}
                  onHide={() => {
                      this.props.closeModal()
                  }}
                 >
            <Modal.Header>
                <Modal.Title>{this.props.modalTitleText ? this.props.modalTitleText :'Are you sure you want to delete this record?'}</Modal.Title>
            </Modal.Header>

            <Modal.Footer>
                <Button onClick={(e)=>  this.props.closeModal()}>{this.props.cancelButtonText ? this.props.cancelButtonText:'Cancel'}</Button>
                <Button onClick={(e)=>  this.removeRecord() } className="left20" bsStyle="primary">{this.props.confirmButtonText ? this.props.confirmButtonText:'Delete'} </Button>
            </Modal.Footer>
        </Modal>


        );
    }
}

